import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/UIElements'
import '../styles/d3/onboardingPrompt.scss'
import { closeIcon, humiS, isabellaS } from '../assets/assets'

const strings = {
  greeting: {
    humi: 'Hi again!',
    isabela: 'Hello there!',
  },
  message: {
    humi:
      "Here are your activities to complete. They'll be displayed here as your study team sends them along.",
    isabela: "I'll pass along announcements from your study team.",
  },
}

const OnboardingPrompt = ({ type, closeFunc }) => {
  const isActivities = type === 'activities'
  return (
    <div className={`onboarding${isActivities ? '' : ' announcements'}`}>
      <Button onClick={() => closeFunc()}>{closeIcon()}</Button>
      <div className='flexed'>
        <div>
          <img
            className={!isActivities ? 'isabella-onboarding' : ''}
            src={isActivities ? humiS : isabellaS}
            alt='activities-onboarding-humi'
          />
        </div>
        <div>
          <p>{strings.greeting[isActivities ? 'humi' : 'isabela']}</p>
          <p>{strings.message[isActivities ? 'humi' : 'isabela']}</p>
        </div>
      </div>
    </div>
  )
}

OnboardingPrompt.propTypes = {
  type: PropTypes.string,
  closeFunc: PropTypes.func,
}

export default OnboardingPrompt



// WEBPACK FOOTER //
// ./src/components/OnboardingPrompt.js